import React, { Fragment, useContext, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Typography, Grid, Divider } from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";

// Contexts
import ProductContext from "../../../context/checkout/products/ProductContext";
import CampaignContext from "../../../context/campaign/CampaignContext";

// Components
import Offer from "./product_form/Offer";
import Presell from "./product_form/Presell";
import Upsell from "./product_form/Upsell";

const useStyles = makeStyles(() => ({
  section: {
    marginTop: "0.1rem",
  },
  divider: {
    marginTop: "1rem",
    marginBottom: "0.5rem",
  },
  skeleton: {
    borderRadius: "5px",
  },
}));

const Section_03 = () => {
  const classes = useStyles();

  const { all_products, products, setProducts } = useContext(ProductContext);
  const { form_data } = useContext(CampaignContext);

  useEffect(() => {
    if (all_products && form_data.posting_store) {
      const filtered = all_products.filter(
        (product) => product.store_name === form_data.posting_store
      );

      setProducts(filtered);
    }
  }, [all_products, form_data.posting_store]);

  return (
    <Grid container>
      <Grid item xs={12}>
        <Typography variant="caption" color="primary">
          Step 3: Product Details
        </Typography>
      </Grid>
      {products ? (
        <Fragment>
          <Grid
            item
            xs={12}
            spacing={2}
            container
            alignItems="flex-start"
            justifyContent="flex-start"
            className={classes.section}
          >
            <Offer />
          </Grid>
          <Grid item xs={12}>
            <Divider variant="fullWidth" className={classes.divider} />
            <Grid item container>
              <Presell />
              <Upsell />
            </Grid>
          </Grid>
        </Fragment>
      ) : (
        <Skeleton
          variant="rect"
          height={100}
          width="100%"
          className={classes.skeleton}
        />
      )}
    </Grid>
  );
};

export default Section_03;
